import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { SatelliteHeartbeatViewStore } from "../../store";
import { SatelliteHeartbeatView } from "./SatelliteHeartbeatView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type SatelliteHeartbeatDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const SatelliteHeartbeatDrawerContent: React.FC<SatelliteHeartbeatDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new SatelliteHeartbeatViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return <SatelliteHeartbeatView satelliteHeartbeatViewStore={viewStore} />;
  });
